import { render, staticRenderFns } from "./IrrigationPlan.vue?vue&type=template&id=2b798214&scoped=true"
import script from "./IrrigationPlan.vue?vue&type=script&lang=js"
export * from "./IrrigationPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b798214",
  null
  
)

export default component.exports